module.exports = __webpack_public_path__ + "94f03824258944f922b7bf42d4cb4138.svg";